import TechSectionHeader from "./TechSectionHeader";
import TechStackGrid from "./TechStackGrid";
import { databaseTech } from "./technologies.data";

export default function TechDatabase() {
  return (
    <section className="tech-section">
      <TechSectionHeader
        title="Database"
        highlight="Technologies"
        subtitle="Reliable, scalable, and secure data storage solutions."
      />

      <TechStackGrid items={databaseTech} />
    </section>
  );
}
